import { reactMount } from '@/lib/reactMount'
import { useRef } from 'react'
import { InfoCircle } from '@/components/Icons'
import { Button } from '@/components/Button'
import { AccentBar } from '@/components/AccentBar'

export const columnBlock = ({ dataset, umbraco }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current

  const theme = umbraco.Theme || 'light'
  const backgroundColor = umbraco.BlockBackground ? `#${umbraco.BlockBackground}` : '#ffffff'

  const itemCount = umbraco.Blocks.length
  let itemCountClasses = ''

  if (itemCount === 5) itemCountClasses = 'w-full grid md:flex flex-wrap md:justify-center xl:grid xl:grid-cols-5'
  if (itemCount === 4) itemCountClasses = 'w-full grid md:grid-cols-2 lg:grid-cols-4'
  if (itemCount === 3) itemCountClasses = 'w-full grid md:grid-cols-3'
  if (itemCount === 2) itemCountClasses = 'w-full grid md:grid-cols-2'

  return (
    <div
      data-theme={theme}
      id={umbraco.AnchorTarget || undefined}
      className='_block-section _columnBlock-section relative isolate py-16 md:px-4 lg:px-10 xl:px-24'
      style={{ backgroundColor }}
    >
      <AccentBar className='h-[200px]' umbraco={umbraco} />
      {(umbraco.Title || umbraco.SubTitle || umbraco.Summary) &&
        <div className='text-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-14'>
          {
          umbraco.Title &&
            <h2 className='text-3xl font-extrabold sm:text-5xl mb-4 tracking-tight text-[--theme-highlight]'>{umbraco.Title}</h2>
        }
          {
          umbraco.SubTitle &&
            <h3 className='text-2xl font-extrabold sm:text-3xl tracking-tight text-[--theme-text-alt-3]'>{umbraco.SubTitle}</h3>
        }
          {umbraco.Summary &&
            <div
              className='mx-auto max-w-5xl sm:px-4 md:px-7 text-[--base-text] text-pretty text-base sm:text-lg font-semibold mt-5 first:mt-0'
              dangerouslySetInnerHTML={{ __html: umbraco.Summary }}
            />}
        </div>}
      <div className={`mx-auto max-w-[1464px] px-4 xl:px-3 isolate gap-4 ${itemCountClasses}`}>
        {umbraco.Blocks.map((block, index) => {
          const TagName = block.Button?.Url ? 'a' : 'div'
          const tagProps = block.Button?.Url
            ? { href: block.Button.Url, target: block.Button.Target || '_self' }
            : {}

          return (
            <TagName
              key={`column-block-${index}`}
              className={` ${itemCount === 5 ? 'w-full md:w-[calc(33.333333%-16px)] xl:w-full' : ''}  group relative rounded-[20px] overflow-hidden bg-default-50 duration-300 h-[360px] text-[--theme-text-light]`}
              {...tagProps}
            >
              <div>
                <img className='absolute inset-0 object-cover w-full h-full' src={block.Media.Image.Url} alt={block.Media.Image.AltText} />
                <div className='absolute inset-0 bg-black/10 before:content-[""] before:absolute before:inset-0 before:bg-gradient-card' />
              </div>
              {(block.Summary || block.Button) && (
                <InfoCircle className='size-8 absolute left-6 top-6 pointer-events-none text-[--theme-text]' aria-hidden='true' />
              )}
              <div className='p-6 absolute inset-x-0 bottom-0 flex flex-col pt-20 translate-y-[calc(100%_-_166px)] group-hover:translate-y-0 transition-transform duration-300'>
                {
              block.Title &&
                <h3 id={`column-block-${index}`} className='text-2xl font-extrabold mb-2 flex items-end h-[64px]'>
                  <span className='line-clamp-2'>
                    {block.Title}
                  </span>
                </h3>
            }
                {
              block.Summary &&
                <div
                  className='text-sm max-w-lg text-pretty font-extrabold mt-1 line-clamp-5 opacity-0 group-hover:opacity-100 transition duration-200'
                  dangerouslySetInnerHTML={{ __html: block.Summary }}
                />
            }
                {
              block.Button &&
                <div data-theme='dark' className='grow flex items-end pt-4'>
                  <Button
                    noInteraction
                    variant='link'
                    size='sm'
                  >
                    {block.Button.Name || 'Learn more'}
                  </Button>
                </div>
            }
              </div>
            </TagName>
          )
        })}
      </div>
      {umbraco.FooterCallout &&
        <div
          className='mx-auto max-w-2xl text-center _simple-rte pt-12'
          dangerouslySetInnerHTML={{ __html: umbraco.FooterCallout }}
        />}
    </div>
  )
}

reactMount('columnBlock', columnBlock)
